import { createToolkitTheme } from '@jpmuitk/theme';

export const lightTheme = createToolkitTheme('light');
export const darkTheme = createToolkitTheme('dark');
